import {PlayersStatisticsTableApiModel} from "./players-statistics.table.api-model";
import {BaseDomainModel} from "../../../../../infrastructure/models/base-domain-model";
import {PlayersStatisticsTableColumnApiModel} from "./columns/players-statistics.table.column.api-model";
import {PlayersStatisticsTableColumnDomainModel} from "./columns/players-statistics.table.column.domain-model";
import {PlayersStatisticsTableRowsMembersApiModel} from "./rows/member/players-statistics.table.row.member-row.api-model";
import {PlayersStatisticsTableRowMemberRowDomainModel} from "./rows/member/players-statistics.table.row.member-row.domain-model";
import {PlayersStatisticsTableRowSummaryRowApiModel} from "./rows/summary/players-statistics.table.row.summary-row.api-model";
import {PlayersStatisticsTableRowSummaryRowDomainModel} from "./rows/summary/players-statistics.table.row.summary-row.domain-model";
import {PlayersStatisticsTableGroupApiModel} from "./groups/players-statistics.table.group.api-model";
import {PlayersStatisticsTableGroupDomainModel} from "./groups/players-statistics.table.group.domain-model";
import {LineupsMemberDomainModel} from "../../lineups-member/lineups-member-domain-model";
import {
  PlayersStatisticsTableColumnGroupDomainModel
} from "./columnsGroups/players-statistics.table.column-group.domain-model";
import type {
  PlayersStatisticsTableColumnGroupApiModel
} from "./columnsGroups/players-statistics.table.column-group.api-model";

export class PlayersStatisticsTableDomainModel extends BaseDomainModel {
  apiModel: PlayersStatisticsTableApiModel;
  members: Array<LineupsMemberDomainModel>;

  constructor(apiModel: PlayersStatisticsTableApiModel, members: Array<LineupsMemberDomainModel>) {
    super(apiModel);

    this.members = members;
  }

  get categoryId(): Number {
    return this.apiModel.categoryId;
  }

  get columns(): Array<PlayersStatisticsTableColumnDomainModel> {
    const columns: PlayersStatisticsTableColumnDomainModel = this.apiModel.columns?.map((column: PlayersStatisticsTableColumnApiModel) => new PlayersStatisticsTableColumnDomainModel(column));

    return columns;
  }

  get groups(): Array<PlayersStatisticsTableGroupDomainModel> {
    const groups: PlayersStatisticsTableGroupDomainModel = this.apiModel.groups?.map((group: PlayersStatisticsTableGroupApiModel) => new PlayersStatisticsTableGroupDomainModel(group));

    return groups;
  }

  get rows(): Array<PlayersStatisticsTableRowMemberRowDomainModel> {
    const rows: PlayersStatisticsTableRowMemberRowDomainModel = this.apiModel.rows?.map((row: PlayersStatisticsTableRowsMembersApiModel) => {
      const member: LineupsMemberDomainModel = this.members?.find(member => member.id === row.playerId)

      return new PlayersStatisticsTableRowMemberRowDomainModel(row, member)
    });

    return rows;
  }

  get summary(): Array<PlayersStatisticsTableRowSummaryRowDomainModel> {
    const summary: PlayersStatisticsTableRowSummaryRowDomainModel = this.apiModel.summary?.map((summaryAM: PlayersStatisticsTableRowSummaryRowApiModel) => new PlayersStatisticsTableRowSummaryRowDomainModel(summaryAM));

    return summary;
  }

  get columnGroups(): Array<PlayersStatisticsTableColumnGroupDomainModel> {
    const columnGroups: PlayersStatisticsTableColumnGroupDomainModel = this.apiModel.columnsGroups?.map((columnGroup: PlayersStatisticsTableColumnGroupApiModel) => new PlayersStatisticsTableColumnGroupDomainModel(columnGroup));

    return columnGroups;
  }
}
